<hd-dialog
  [dialogTitle]="config.titleKey || 'general.confirm.title'"
  [closeRequested]="closeRequested"
>
  <ng-container dialogActions>
    <button class="filled"
            (click)="submittedSuccessfully.emit()">{{ (config.submitLabelKey || 'general.confirm.submit') | translate }}
    </button>
  </ng-container>

  <ng-container dialogContent>
    <div class="flex flex-col gap-4">
      @if (config.questionKey) {
        <div class="text-error-fill font-medium" [innerHTML]=" config.questionKey | translate"></div>
      }
      @if (config.descriptionKey) {
        <div>{{ config.descriptionKey | translate }}</div>
      }

      @if (config.reason) {
        <hd-textarea
          [label]="config.reason.label"
          [description]="config.reason.description"
          [placeholder]="config.reason.placeholder"
          [control]="config.reason.control"/>
      }
    </div>

  </ng-container>
</hd-dialog>
